import styled from 'styled-components';
import tw from 'twin.macro';

export const PaymentOptionRadioContainer = styled('div')`
  margin-bottom: 16px;
  .paymentModeOption {
    border: none;
    margin-bottom: 16px;
  }
  .paymentOptionRadioButton {
    display: none;
  }
  .paymentOptionClassName {
    border: none;
    & > span {
      width: 100%;
    }
    padding: unset !important;
  }
  .paymentModeRadioButton {
    margin-right: 16px;
  }
`;

export const PaymentOptionContainer = styled('div')`
  ${tw`w-full px-4 flex flex-col justify-center`}
  border: 1px solid #94A3B8;
  border-radius: 16px;
  padding: 12px;
  border-color: ${(props) => (props.isSelected ? '#2563EB' : '#94A3B8')};
`;

export const PaymentOptionDescriptionText = styled('span')`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #334155;
`;

export const PaymentOptionImage = styled('img')`
  ${tw`w-102px h-6`}
`;

export const PaymentModeOptionContainer = styled.div`
  display: ${(props) => (props.isSelected ? 'block' : 'none')};
`;

export const LineBreak = styled.div`
  height: 1px;
  width: 100%;
  background-color: #dfdfdf;
  margin-top: 14px;
`;

export const PaymentModeImagesContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
`;
export const DigitalPaymentModeImages = styled.img`
  margin-right: 8px;
  height: 16px;
`;
export const BankTransferPaymentModeImages = styled.img`
  height: 28px;
`;
